export const SOURCE_PLAY_HLS = 'source-play-hls';
export const SOURCE_PLAY_DASH = 'source-play-dash';
export const SOURCE_PLAY_MP4 = 'source-play-mp4';
export const SOURCE_PLAY_TRIM_HLS = 'source-play-trim-hls';
export const SOURCE_PLAY_TRIM_MP4 = 'source-play-trim-mp4';
export const SOURCE_PLAY_WEBM = 'source-play-webm';
export const SOURCE_PLAY_WEBM_STREAMED = 'source-play-webm-streamed';

export const THUMB_DEFAULT = 'default';
export const THUMB_DEFAULT_PLAY = 'default-play';
export const THUMB_DEFAULT_4x3 = 'default-4x3';
export const OG_THUMB_FULL = 'og-full'; // unedited thumb
export const THUMB_FULL = 'full';
export const THUMB_FULL_PLAY = 'full-play';
export const THUMB_GIF = 'default-gif';
export const THUMB_GIF_PLAY = 'default-gif-play';
export const THUMB_VIDEO_PREVIEW = 'animated-preview';

export const THUMB_EXT_JPG = 'jpg';
export const THUMB_EXT_PNG = 'png';

export const ARCHIVED_ANY = 'any'; // both archived and not
export const ARCHIVED_EXCLUDED = 'excluded'; // no archived videos
export const ARCHIVED_EXCLUSIVELY = 'exclusively'; // only archived videos

export const VIDEO_PRIVACY_PUBLIC = 'public';
export const VIDEO_PRIVACY_WORKSPACE = 'workspace';
export const VIDEO_PRIVACY_OWNER = 'owner';
export const VIDEO_PRIVACY_CUSTOM_ACCESS = 'custom'; // used only for UI purposes, is not a valid video.privacy value

export const VIDEO_PRIVACY_TYPES = [
  VIDEO_PRIVACY_PUBLIC,
  VIDEO_PRIVACY_WORKSPACE,
  VIDEO_PRIVACY_OWNER,
];

export const V4_SINGLE_BITRATE = 'singlebitrate';

export const DEFAULT_PRIVATE_THUMBNAIL_PATH: Record<string, string> = {
  '.png': 'placeholders/private-video.png',
  '.jpg': 'placeholders/private-video.jpg',
  '.gif': 'placeholders/private-video.gif',
};

export const DEFAULT_PASSWORD_PROTECTED_THUMBNAIL_PATH: Record<string, string> =
  {
    '.png': 'placeholders/password-video.png',
    '.jpg': 'placeholders/password-video.jpg',
    '.gif': 'placeholders/password-video.gif',
  };

export const WAVEFORM_IN_PROGRESS = 'inProgress';
export const WAVEFORM_SUCCESS = 'success';
export const WAVEFORM_FAILURE = 'failure';
export const WAVEFORM_NO_AUDIO = 'no_audio';
export const WAVEFORM_GENERATION_STATUSES = [
  WAVEFORM_IN_PROGRESS,
  WAVEFORM_SUCCESS,
  WAVEFORM_FAILURE,
];
